var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-crud',{attrs:{"crudName":"Relatório de Eventos - Geral","newText":"Novo Turno","table":_vm.eventTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableExtract":true,"enableAdd":false,"enableEdit":false,"enableDelete":true,"enableView":true,"enablePdf":false,"with":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ad276f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Event/Crud.vue
// module id = null
// module chunks = 